import { MissingRequiredParameterError } from './errors';
import { commonIntegrationDataToQuery, integrationDataFromQuery } from './integration-data';
export function thankYouDataFromQuery(query) {
  const _integrationDataFromQ = integrationDataFromQuery(query),
    minStartDate = _integrationDataFromQ.minStartDate,
    maxStartDate = _integrationDataFromQ.maxStartDate,
    navigateTo = _integrationDataFromQ.navigateTo,
    navigateToPageProps = _integrationDataFromQ.navigateToPageProps,
    navigateToSectionProps = _integrationDataFromQ.navigateToSectionProps,
    verticalStatusContent = _integrationDataFromQ.verticalStatusContent,
    biOptions = _integrationDataFromQ.biOptions;
  const orderId = query.get('orderId');
  if (!orderId) {
    throw new MissingRequiredParameterError('orderId');
  }
  return {
    successful: true,
    ownerDemo: query.get('ownerDemo') === 'true',
    orderId,
    planId: undefined,
    minStartDate,
    maxStartDate,
    navigateTo,
    navigateToPageProps,
    navigateToSectionProps,
    verticalStatusContent,
    biOptions,
    checkoutFlowId: query.get('checkoutFlowId') ?? undefined
  };
}
export function thankYouDataToQuery(data) {
  const _data$purchaseData$ch = data.purchaseData.checkoutData,
    integrationData = _data$purchaseData$ch.integrationData,
    checkoutFlowId = _data$purchaseData$ch.checkoutFlowId;
  const query = commonIntegrationDataToQuery(integrationData);
  query.set('orderId', data.purchaseData.orderId);
  data.ownerDemo && query.set('ownerDemo', 'true');
  checkoutFlowId && query.set('checkoutFlowId', checkoutFlowId);
  return query;
}
//# sourceMappingURL=thank-you-data.js.map